import React from 'react';

const Triangles = () => {
    return (
        <div className='oa_triangle_breaker'>
            <div className='oa_triangle down'></div>
            <div className='oa_triangle up'></div>
            <div className='oa_triangle down'></div>
        </div>
    );
};

export default Triangles;
